import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate, Link, NavLink } from 'react-router-dom';
import $ from "jquery";

function Footer() {
    
 return (
    
    <>
    <style>
		{
			`
			#footer .footer-copyright.footer-copyright-style-2 {
                background: #D21677;
                border-top: 1px solid rgba(255, 255, 255, 0.05);
            }
                #footer a,p {
                    color: #ffffff;
                }
			`
		}
		</style>
        <div>
         <footer id="footer" className="mt-0 " style={{ borderTopLeftRadius: '0px', backgroundColor: '#D21677', border:'#D21677' }}>
                <div className="container container-xl-custom my-4">
                    <div className="row py-5">
                        <div className="col-lg-4 mb-5 mb-lg-0 text-center text-lg-start pt-3">
                         <h5 className="text-5 text-transform-none font-weight-semibold text-color-light mb-4">  Radius Exhibition Fixtures,</h5>
                         <p className="text-4 mb-3 text-white">Radius is Interior Fit Out Company in Dubai which established in 2007 and built on a legacy of uncompromising craftsmanship and world-class project management.</p>
                        </div>
                       
                        <div className="col-lg-4 mb-4 mb-lg-0 text-center text-lg-start pt-3">
                            <h5 className="text-5 text-transform-none font-weight-semibold text-color-light mb-4">Contact Us</h5>
                         <p className="text-4 mb-2 text-white"><span className="text-color-light">Address:</span> P.O. Box: 123635 – Dubai, UAE</p>
                             <p className="text-4 mb-2"><span className="text-color-light">Phone:</span> <a href="tel:04 267 5433" className='text-white' style={{ textDecoration: 'none' }}>04 267 5433</a></p>
                             <p className="text-4 mb-2"><span className="text-color-light">Email:</span> <a href="" style={{ textDecoration: 'none' }}><span className="__cf_email__ text-white">contact@radius.com</span></a></p>
                        </div>
                        <div className="col-lg-4 text-center text-lg-start pt-3">
                            <h5 className="text-5 text-transform-none font-weight-semibold text-color-light mb-4">Follow Us</h5>
                            <ul className="footer-social-icons social-icons social-icons-clean social-icons-big social-icons-opacity-light social-icons-icon-light mt-0 mt-lg-3">
                                <li className="social-icons-facebook"><a href="http://www.facebook.com/" target="_blank" title="Facebook"><i className="fab fa-facebook-f text-2"></i></a></li>
                                <li className="social-icons-x"><a href="http://www.x.com/" target="_blank" title="X"><i className="fab fa-x-twitter text-2"></i></a></li>
                                <li className="social-icons-linkedin"><a href="http://www.linkedin.com/" target="_blank" title="Linkedin"><i className="fab fa-linkedin-in text-2"></i></a></li>
                            </ul>
                        </div>
                    </div>
                </div>
                 <hr className="m-0" style={{ border: '1px solid #ffffff' }} />
                <div className="container container-xl-custom">
                    <div className="footer-copyright footer-copyright-style-2" >
                        <div className="py-2">
                            <div className="row py-4">
                                <div className="col d-flex align-items-center justify-content-center mb-4 mb-lg-0 text-white">
                                     <p className='text-white' style={{ fontSize: '17px' }}>Copyright © Radius Exhibition Fixtures 2026, website by <a href="https://convexad.com/" className='text-white'><strong>CONVEX</strong> </a></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
            <div className="whatsapp_chat_support wcs_fixed_left wcs-effect-1 d-none" id="example">
                 <div className="wcs_button wcs_button_ circle" style={{ background: '#D21677', padding: '8px 9px'}}>
                    <a className="fab fa-whatsapp text-2" style={{fontSize: '29px', padding: '5px', color: 'white'}}></a>
                </div>
                <div className="wcs_popup">
                    <div className="wcs_popup_close">
                        <span className="fa fa-close"></span>
                    </div>
                    <div className="wcs_popup_header">
                        <strong>Need Help? Chat with us</strong>
                        <br/>
                            <div className="wcs_popup_header_description">Click one of our representatives below</div>
                    </div>
                    <div className="wcs_popup_person_container">
                        <div className="wcs_popup_person" data-number="+971502630264" data-availability="{&quot;monday&quot;:&quot;08:30-23:30&quot;, &quot;tuesday&quot;:&quot;08:30-23:30&quot;, &quot;wednesday&quot;:&quot;08:30-23:30&quot;, &quot;thursday&quot;:&quot;08:30-23:30&quot;, &quot;friday&quot;:&quot;08:30-23:30&quot;,&quot;saturday&quot;:&quot;08:30-23:30&quot;,&quot;sunday&quot;:&quot;08:30-23:30&quot; }">
                            <div className="wcs_popup_person_img"><img src="https://robespa.gemsdrive.co.uk/269-avatar-female.svg" alt=""/></div>
                            <div className="wcs_popup_person_content">
                                <div className="wcs_popup_person_name">Booking Agent</div>
                                <div className="wcs_popup_person_status">I'm Online</div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </>
    );
}

export default Footer;
